export default "__VITE_ASSET__MzqCSRtd__"